const INTEGER_PATTERN = /^\d+$/;

/** Returns a valid integer or undefined */
export const tryParseInternalId = (value: string) => {
  if (!INTEGER_PATTERN.test(value)) return undefined;
  const number = parseInt(value, 10);

  if (!Number.isSafeInteger(number)) return undefined;

  return number;
};

export const validateInternalId = (value: string): boolean => {
  const parsed = tryParseInternalId(value);

  return parsed !== undefined;
};
